<template>
  <div :class="classes">
    <div :class="innerClasses" ref="inner">
      <slot />
    </div>
  </div>
</template>
<script>
import classes from '@/utils/classes'

export default {
  name: 'HintContainer',
  props: {
    className: String,
    innerClassName: String,
  },
  computed: {
    classes() {
      const { className, $style } = this
      return classes($style.wrapper, className && className)
    },
    innerClasses() {
      const { innerClassName, $style } = this
      return classes($style.inner, innerClassName && innerClassName)
    },
  },
  methods: {
    doResize() {
      const { $refs: { inner } } = this
      if (!inner) return
      const { height, top } = inner.getBoundingClientRect()

      if (top < 0) {
        inner.style.height = `${height + top}px`
      }
      if (!this.interacted) {
        inner.scrollTop = inner.scrollHeight
      }

      this.watcher = requestAnimationFrame(this.doResize)
    },
    makeInteracted() {
      this.interacted = true
    },
  },
  mounted() {
    this.interacted = false
    this.watcher = requestAnimationFrame(this.doResize)
    this.$el.addEventListener('wheel', this.makeInteracted, { once: true })
    this.$el.addEventListener('touchstart', this.makeInteracted, { once: true })
  },
  beforeDestroy() {
    cancelAnimationFrame(this.watcher)
  },
}
</script>
<style lang="scss" module>
@import './HintContainer.scss';
</style>
